//------------------------------------------------------------------------------
// BFA10102G 共架申込基本情報
//------------------------------------------------------------------------------
import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import UploadCustom from '@/components/organisms/UploadCustom';
import TitledArea from '@/components/titled-area';
import TooltipLabel from '@/components/tooltip-label';

// 定数
const SIZE_10MB = 10485760;   // サイズ10MB

/**
 * 申込添付パネル
 */
export const OrderAttachPanel = React.memo(({
  updatable,
}) => {
  //
  // 描画
  //
  return (
    <Paper elevation={3} sx={{ px: 3, py: 2 }}>
      <TitledArea title="添付ファイル">

        {/* ルート図 */}
        <Box sx={{ mb: 1 }}>
          <TooltipLabel
            label="ルート図"
            labelProps={{ variant: 'subtitle1' }}
            icon={<InfoOutlined />}
          >
            1ファイルのみ10MBまで登録できます
          </TooltipLabel>
          <UploadCustom
            componentId="route"
            acceptFileType=''
            maxFileCount={1}
            maxFileSize={SIZE_10MB}
            required={false}
            disabled={!updatable}
            previewWidth='35%'
          />
        </Box>

        {/* TODO
          fileSetHandler: null,
          downloadHandler: null,
          customChecks: [checkFileNameLength, checkFileSizeZero],
          initFile: [],
          disabled: true,
        */}

        {/* 共架設備仕様書 */}
        <Box sx={{ mb: 1 }}>
          <TooltipLabel
            label="共架設備仕様書"
            labelProps={{ variant: 'subtitle1' }}
            icon={<InfoOutlined />}
          >
            1ファイルのみ10MBまで登録できます
          </TooltipLabel>
          <UploadCustom
            componentId="spec"
            acceptFileType=''
            maxFileCount={1}
            maxFileSize={SIZE_10MB}
            required={false}
            disabled={!updatable}
            previewWidth='35%'
          />
        </Box>
        
        {/* その他資料 */}
        <Box sx={{ mb: 1 }}>
          <TooltipLabel
            label="その他資料"
            labelProps={{ variant: 'subtitle1' }}
            icon={<InfoOutlined />}
          >
            1ファイルあたり10MB、3ファイルまで登録できます
          </TooltipLabel>
          <UploadCustom
            componentId="other"
            acceptFileType=''
            maxFileCount={3}
            maxFileSize={SIZE_10MB}
            required={false}
            disabled={!updatable}
            previewWidth='35%'
          />
        </Box>
      </TitledArea>
    </Paper>
  );
});

// プロパティ
OrderAttachPanel.propTypes = {
  updatable: PropTypes.bool,  // TODO
};

// デフォルトエクスポート
export default OrderAttachPanel;
